import { ControlPanelMenuItem } from "../types";
import { CONTROL_PANEL_MENU_ITEMS } from "../constants/controlPanelMenuItems.constants";

export function getFilteredMenuItems({
  entitySubdomain,
  currentHost,
}: {
  entitySubdomain: string | null;
  currentHost: string;
}): ControlPanelMenuItem[] {
  const isEntitySelected = !!entitySubdomain && entitySubdomain !== "controlpanel";

  return CONTROL_PANEL_MENU_ITEMS.filter((item) => {
    if (item.requires_entity) {
      return isEntitySelected;
    }
    return true;
  }).map((item) => {
    const entityId = isEntitySelected ? entitySubdomain : "opengov";
    const remainingDomain = currentHost.split(".").slice(1).join(".");
    const fullHost = `${item.subdomain}.${remainingDomain}`;
    const locationTemplate = `//${fullHost}${item.location_template}`;
    const entrypoint = locationTemplate.replace("${entity}", entityId);

    return {
      id: item.id,
      name: item.name,
      location_template: locationTemplate,
      requires_entity: item.requires_entity,
      requires_feature_permission: item.requires_feature_permission ?? undefined,
      entrypoint,
    };
  });
}
